import { EXT_ENDPOINT } from 'consts/api';
import { api } from 'helpers/api';
import { ENGT_CHAT } from 'js/bot.model';

export const getFaqAutocompleteStatements = (ref, indexUid, input, document) => {
	const statements = new Set();
	const payload = { q: input };
	const autoComplete = document.querySelector('#engtFaqAutocompleteWrapper');

	ref.initComponents();
	const closePopup = () => {
		if (autoComplete) autoComplete.innerHTML = '';
		ref.closeFaqAutocompletePopUp();
		ref.hideArrowBtns();
	};

	if (input.length > 2) {
		api('POST', EXT_ENDPOINT().FAQ_AUTOCOMPLETE_PATH + indexUid, { payload: JSON.stringify(payload) })
			.then((resp) => {
				if (resp?.responseText) {
					const response = JSON.parse(resp.responseText);
					response.hits?.forEach((hit) => statements.add(hit.statement));
					if (statements.size) {
						ref.reRenderFaqAutoComplete(Array.from(statements));
						ref.changeBtnToDownArrow();
						if (ENGT_CHAT.get('isFaqAcPopUpClose')) {
							ref.closeFaqAutocompletePopUp();
						}
					} else {
						closePopup();
					}
				}
			})
			.catch((e) => {
				console.error('replyinput.api.js: exception in get faq autocomplete data api', e);
			});
	} else {
		closePopup();
	}
};
